import React from "react";
import styled, { withTheme }from "styled-components";
import { Select } from "antd";

const Option = Select.Option;
const OptionStyle = (color)=>`
    .ant-select-dropdown-menu-item-active{ 
        background-color:${color};
        color:#FFF;
    }
    .option:hover { 
        background-color:${color};
        color:#FFF;
    }
`;

const Selection = props => {
	const { optionProps, SelectionContainer, theme } = props;

	return (
		<div style={{display:"inline-block"}} >
			<style key={1}>{OptionStyle(theme.mainColor)}</style>
			<Select
				style={{ width: 180 }}
				onChange={props.onChange}
				{...props}
			>
				{
					optionProps.map((optionElement, index) => {
    
						return <Option key={index} className="option" value={optionElement.value}>
							{optionElement.name}
						</Option>;
					})
				}
			</Select>
		</div>);};
export default withTheme(Selection);


// WEBPACK FOOTER //
// ./src/components/form/Selection.js